
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1625710316933",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "21058",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M763.648 488.71466666L328.096 49.96266666c-9.696-9.696-25.824-9.696-35.488 0s-9.696 25.824 0 35.488l419.424 419.424-419.424 429.12c-9.696 9.696-9.696 25.824 0 35.488s25.824 9.696 35.488 0l435.552-445.248a25.28 25.28 0 0 0 0-35.488z",
        "fill": "",
        "p-id": "21059"
      }
    }
  ]
})
    }
  